import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { PageLoaderService } from './page-loader.service';

@Component({
  selector: 'app-pageloader',
  styleUrls: ['./page-loader.component.scss'],
  templateUrl: './page-loader.component.html'
})

export class PageLoaderComponent implements OnInit {
  pageStatus: boolean;
  constructor(private pageLoaderService: PageLoaderService) {
  }

  ngOnInit() {
    this.pageLoaderService.getPageLoaderStatus().subscribe(
      (status: boolean) => {
        this.pageStatus = status;
      }
    );
  }
}
